export default {
  logistics: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Warehouse & logistics',
    hero: {
      eyebrow: 'Warehouse & logistics',
      title: 'Large-area surveillance for logistics and warehouses',
      lead: 'Wide angle, PTZ and night vision – we cover large halls and outdoor areas with few but well-placed cameras.',
    },
    areas: {
      title: 'Surveillance areas in warehouses and logistics',
      lead: 'From the entrance to packaging: we structure your surveillance along the flow of goods – so no gaps arise.',
      items: {
        '0': { title: 'Entrance & exit', desc: 'Every vehicle crossing your site is captured – including number plate and timestamp for complete documentation.' },
        '1': { title: 'Delivery zone', desc: 'Goods arrival and pickup are sensitive moments. Cameras document every action at the ramp.' },
        '2': { title: 'Pallet racks', desc: 'Large halls need large solutions. PTZ cameras pan across the aisles and zoom to the pallet when needed.' },
        '3': { title: 'Order picking', desc: 'Packaging and picking are characterised by movement. Overview cameras provide clarity in complaints.' },
        '4': { title: 'Outdoor area & yard', desc: 'The perimeter is the first line of defence. Weatherproof cameras monitor fences, gates and parked vehicles.' },
        '5': { title: 'Office & administration', desc: 'The administrative area also needs protection – for valuables, documents and sensitive access.' },
      },
    },
    coverage: {
      eyebrow: 'Large areas in view',
      title: 'One camera, great effect',
      lead: 'In warehouses, the overview is what matters. Instead of many individual cameras, we use technology that intelligently covers large areas – and stays clearly calculable.',
      items: {
        '0': { title: 'PTZ cameras', desc: 'Pan, tilt, zoom – one camera covers large areas and delivers detail shots when needed.' },
        '1': { title: 'Wide-angle overview', desc: 'For hall sections and outdoor areas: compact wide-angle cameras capture large areas in one image.' },
        '2': { title: 'Day & night vision', desc: 'Infrared and highly sensitive sensors deliver usable images even in darkness – around the clock.' },
      },
    },
    roundClock: {
      eyebrow: 'Around the clock',
      title: 'Recording that never sleeps',
      lead: 'Goods traffic does not stop at night. Your system records around the clock and makes relevant events immediately findable.',
      list: {
        '0': '24/7 recording on a local recorder with a defined retention period',
        '1': 'Event-based recording saves storage and makes searching easier',
        '2': 'Alarm forwarding to defined persons on movement in restricted areas',
        '3': 'Regular maintenance by SSG Care for lasting availability',
        '4': 'Expandable with additional cameras and further locations',
      },
      note: 'Note: The retention period of recordings should be adapted to operational and possibly legal requirements. We advise you on this.',
    },
    cta: {
      title: 'Your logistics – completely documented',
      lead: 'We analyse the flow of goods and risk points and plan a system that fits your hall structure.',
      primary: 'Arrange a consultation',
      secondary: 'Discover SSG Care',
    },
  },
};